// extracted by mini-css-extract-plugin
export default {"PickerBox":"Picker_PickerBox__h0Amg","Red":"Picker_Red__4uZuB"};